














import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import DataPasien from "@/services/DataPasien";
import CardModalAlergi from "@/components/modal/CardModalAlergi.vue";
import { storePasien } from "@/store/modules/pasien";

@Component({
  components: {
    CardModalAlergi
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class AnamnesisPage extends Vue {
  @Prop() readonly register;
  @Prop() readonly rm;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  isAlergiModalShow = false;

  addAlergi(value) {
    appModule.setLoading(true);

    const dt = DataPasien.updateAlergiPasien(this.rm, value);
    dt.then(dt => {
      if (dt["status"] == 1) {
        storePasien.getDataPasien(this.rm);
      }
    }).finally(() => {
      appModule.setLoading(false);
    });
  }
}
